/* istanbul ignore next */
export class GasRequestStatusViewModel {
  requestId = 0;
  bcaId = 0;
  applicantName = '';
  requestStatus = '';
  requestDate?: Date = new Date();
  installationDate?: Date = new Date();
  denialReasonDesc = '';
  ContractRejectionReason = '';
  projectIsActiveYN = ''; //Service Tracker Change CXCO-813,815 (shruti-6/4/2024)
  projectCancelYN='';
  serviceFormattedAddress:string='';
  onHold='';
  projectCompletionSle='';
  projectCompletion='';
    approach = '';
    serviceWRStatus = '';
    isAllServiceRequest = '';
    task2540Status = '';
    task2535Status = '';
}
